import React from 'react';


export default function DefaultImage() {
  return (
    <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M65 27.6667H65.0533M22.3333 1H81C85.2435 1 89.3131 2.68571 92.3137 5.68629C95.3143 8.68687 97 12.7565 97 17V75.6667M92.4347 92.1947C90.9445 93.7164 89.1654 94.9253 87.2019 95.7504C85.2384 96.5756 83.1299 97.0004 81 97H17C12.7565 97 8.68687 95.3143 5.68629 92.3137C2.68571 89.3131 1 85.2435 1 81V17C1 12.4933 2.86133 8.424 5.85333 5.51733M1 70.3333L27.6667 43.6667C32.616 38.904 38.7173 38.904 43.6667 43.6667L70.3333 70.3333M72.0933 50.8027C75.1547 50.5147 78.2533 51.688 81 54.3333L97 70.3333M1 1L97 97" stroke="#071013" strokeOpacity="0.5" strokeWidth="2" strokeLinejoin="round"/>
</g>
</svg>

  )
}
